"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExtension = void 0;
function isExtension(value) {
    return "setup" in value && "start" in value;
}
exports.isExtension = isExtension;
//# sourceMappingURL=Extension.js.map